"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDownloadDocument;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _useReadDocument2 = _interopRequireDefault(require("../useReadDocument"));

var _context2 = require("../../context");

/*
  Download Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useDownloadDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useDownloadDocument`');
  }

  var _useReadDocument = (0, _useReadDocument2.default)('', {
    skip: true
  }),
      refetch = _useReadDocument.refetch;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var downloadDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, fileName) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                refetch(path).then(function (resp) {
                  var _options$onCompleted;

                  if (resp) {
                    var blob = new Blob([resp.content], {
                      type: 'application/octet-stream'
                    });
                    var link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                  }

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options);
                  res();
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadDocument(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [downloadDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/useDownloadDocument/useDownloadDocument.js
// module id = 1830
// module chunks = 0